import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { Quiz } from "@/components/Quiz";
import { Faq } from "@/components/Faq";
import { Founder } from "@/components/Founder";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const target = sessionStorage.getItem("alvirah_scroll");
    if (target) {
      sessionStorage.removeItem("alvirah_scroll");
      setTimeout(() => document.querySelector(target)?.scrollIntoView({ behavior: "smooth" }), 700);
    }
  }, []);

  return (
    <main data-testid="landing-page">
      <Header />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <Portfolio />
      <Quiz />
      <Faq />
      <Founder />
      <Booking />
      <Footer />
    </main>
  );
}
